export class WorkOrder {
  contentExtract({ title, content }: { title?: string; content?: string } = {}) {
    let result: any[] = []
    const dateRegExp = /([^-]+:)?\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/g
    // const dateMatch = record.content.match(dateRegExp)
    const [dateMatchText, dateLabelText] = dateRegExp.exec(content || '') || []

    const contentList = content?.replace?.(dateRegExp, '')?.split?.('-')?.filter(d => d.trim()) || []
    let tempKey: unknown = null
    // let tempLabel: unknown = null
    // console.log('contentList', contentList)
    contentList.map(text => {
      if (/(.*)【(.*)】/g.test(text.trim())) {
        const [, label, value] = text.match(/(.*)【(.*)】/) || []
        if (label) {
          result.push({ label, value })
        }
      }

      text = text.replace(':', '：')

      if (text.includes('：')) {
        const [label, value] = text.split('：', 2)
        // let _label = label
        // if (tempLabel) {
        //   _label = tempLabel + '-' + label
        // }
        if (label) {
          result.push({ label: label.trim(), value })
        }
        tempKey = label.trim()
        // tempLabel = null
      } else {
        if (tempKey) {
          result = result.map(d => {
            if (d.label === tempKey && text) {
              d.value += '-' + text
            }
            return d
          })
        }
        // else if (!text.startsWith('【')) {
        // tempLabel = text
        // }
      }
    })
    // console.log('result', result)
    if (dateLabelText) {
      result.push({
        label: dateLabelText.replace(':', ''),
        value: dateMatchText?.replace?.(dateLabelText, '') || '',
      })
    }
    if (!result.length) {
      result = contentList
        .filter(text => text.trim() && text.replace('【', '').replace('】', '').trim() !== title)
        .map(text => ({ value: text.replace('【', '').replace('】', '').trim() }))
    }
    return result
  }
}

export default new WorkOrder()
